import React from "react";
import { Sparkle } from "lucide-react";

const BADGES = [
  "Dermatologist Tested",
  "100% Vegan",
  "Cruelty-Free",
  "Ethically Sourced",
  "AYUSH Certified",
  "Made in India",
  "Clinically Inspired",
  "Recyclable Glass",
];

export default function Marquee() {
  const row = [...BADGES, ...BADGES];
  return (
    <div className="overflow-hidden border-y py-4" style={{ borderColor: "var(--mn-glass-border)", background: "var(--mn-bg2)" }} data-testid="trust-marquee">
      <div className="flex w-max animate-marquee items-center">
        {row.map((b, i) => (
          <span key={i} className="flex items-center gap-6 pr-6 font-mono text-[0.65rem] uppercase tracking-[0.3em]" style={{ color: "var(--mn-text2)" }}>
            {b}
            <Sparkle size={10} style={{ color: "var(--mn-gold)" }} />
          </span>
        ))}
      </div>
    </div>
  );
}
